const backInStockProgrammaticClicks = new WeakSet();
let backInStockRetryTimer;
let pendingBackInStockTrigger;

function backInStockDialogIsOpen() {
  return Boolean(document.querySelector('[role="dialog"] .klaviyo-form'));
}

function backInStockMarketingIsBlocked() {
  const consentWidget = document.querySelector('#reopen_widget, .isense-reopen-widget-button');
  let consentCookie = '';

  try {
    consentCookie = document.cookie;
  } catch (error) {
    return Boolean(consentWidget);
  }

  const consentMatch = consentCookie.match(/(?:^|;\s*)cookieconsent_preferences_disabled=([^;]*)/);

  if (!consentMatch) return Boolean(consentWidget);

  try {
    return decodeURIComponent(consentMatch[1]).split(',').includes('marketing');
  } catch (error) {
    return Boolean(consentWidget);
  }
}

function setBackInStockLoading(loading) {
  document.querySelectorAll('.klaviyo-bis-trigger, [data-back-in-stock-trigger]').forEach((trigger) => {
    trigger.classList.toggle('loading', loading);
    trigger.toggleAttribute('aria-busy', loading);
    trigger.querySelector('.loading-overlay')?.classList.toggle('hidden', !loading);
  });
}

function stopBackInStockRetries() {
  window.clearTimeout(backInStockRetryTimer);
  backInStockRetryTimer = undefined;
  setBackInStockLoading(false);
}

function openConsentPreferences() {
  const changeConsentButton = document.querySelector('.csm-widget-change-consent-button');
  if (changeConsentButton) {
    changeConsentButton.click();
    return;
  }

  const reopenWidget = document.querySelector('#reopen_widget, .isense-reopen-widget-button');
  if (!reopenWidget) return;

  reopenWidget.click();
  window.setTimeout(() => {
    document.querySelector('.csm-widget-change-consent-button')?.click();
  }, 150);
}

function dispatchBackInStockClick(trigger) {
  backInStockProgrammaticClicks.add(trigger);
  trigger.click();
}

function openBackInStockWhenReady(trigger, clickImmediately) {
  const retryDelay = 750;
  const maximumAttempts = 32;
  let attempts = 0;

  stopBackInStockRetries();
  setBackInStockLoading(true);

  const attemptOpen = () => {
    if (backInStockDialogIsOpen()) {
      pendingBackInStockTrigger = undefined;
      stopBackInStockRetries();
      return;
    }

    if (backInStockMarketingIsBlocked()) {
      pendingBackInStockTrigger = trigger;
      stopBackInStockRetries();
      openConsentPreferences();
      return;
    }

    if (attempts >= maximumAttempts) {
      pendingBackInStockTrigger = undefined;
      stopBackInStockRetries();
      return;
    }

    attempts += 1;
    dispatchBackInStockClick(trigger);
    backInStockRetryTimer = window.setTimeout(attemptOpen, retryDelay);
  };

  backInStockRetryTimer = window.setTimeout(attemptOpen, clickImmediately ? 0 : retryDelay);
}

document.addEventListener('click', (event) => {
  const stickyTrigger = event.target.closest('[data-back-in-stock-trigger]');
  const directTrigger = event.target.closest('.klaviyo-bis-trigger');

  if (!stickyTrigger && !directTrigger) return;

  const klaviyoTrigger = stickyTrigger
    ? document.querySelector(stickyTrigger.dataset.backInStockTrigger)
    : directTrigger;

  if (!klaviyoTrigger) return;

  event.preventDefault();

  if (backInStockProgrammaticClicks.has(klaviyoTrigger)) {
    backInStockProgrammaticClicks.delete(klaviyoTrigger);
    return;
  }

  if (backInStockMarketingIsBlocked()) {
    pendingBackInStockTrigger = klaviyoTrigger;
    stopBackInStockRetries();
    openConsentPreferences();
    return;
  }

  pendingBackInStockTrigger = undefined;
  openBackInStockWhenReady(klaviyoTrigger, Boolean(stickyTrigger));
});

document.addEventListener('consentmoSignal', (event) => {
  if (!pendingBackInStockTrigger) return;

  if (!event.detail?.preferences?.marketing) {
    pendingBackInStockTrigger = undefined;
    stopBackInStockRetries();
    return;
  }

  const trigger = pendingBackInStockTrigger;
  pendingBackInStockTrigger = undefined;
  openBackInStockWhenReady(trigger, true);
});

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image && newImgSrc) {
      // Sanitize and validate URL to prevent XSS
      // Remove any whitespace and HTML entities
      const sanitized = String(newImgSrc).trim().replace(/[\s<>"']/g, '');

      // Reject dangerous protocols (check anywhere in string, not just start)
      const dangerousProtocols = /^(javascript|data|vbscript|file|about):/i;
      if (dangerousProtocols.test(sanitized)) {
        return; // Reject dangerous URLs
      }

      try {
        // Try to parse as absolute URL
        const url = new URL(sanitized, window.location.origin);
        // Only allow http and https protocols
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          // Use the properly constructed URL to prevent any encoding issues
          this.image.src = url.href;
        }
      } catch (e) {
        // If URL parsing fails, it's likely a relative URL
        // Additional validation: ensure it doesn't contain dangerous patterns
        if (!sanitized.includes('javascript:') &&
            !sanitized.includes('data:') &&
            !sanitized.includes('vbscript:') &&
            !sanitized.includes('<') &&
            !sanitized.includes('>')) {
          // For relative URLs, ensure proper encoding
          this.image.src = sanitized;
        }
      }
    }
  }
}

customElements.define('upsell-card', UpsellCard);
